import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import LoginPageLayout from "@/components/auth/LoginPageLayout";
import LoginLeftPanel from "@/components/auth/LoginLeftPanel";
import LoginRightPanel from "@/components/auth/LoginRightPanel";
import SEO from "@/components/SEO";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/context/LanguageContext";
import { initGA } from "@/utils/analytics";

const Login = () => {
  const [loaded, setLoaded] = useState(false);
  const [searchParams] = useSearchParams();
  const [emailFromUrl, setEmailFromUrl] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const { t } = useTranslation();
  const { language } = useLanguage();
  
  // Construct ogUrl with language
  const baseUrl = "https://www.anzirtech.com";
  const loginUrl = `${baseUrl}/login`;
  const ogUrl = language === 'en' ? loginUrl : `${baseUrl}/${language}/login`;

  useEffect(() => {
    setLoaded(true);

    // 检查URL中是否有消息参数
    const message = searchParams.get('message');
    if (message) {
      // 显示消息提示
      toast.error(decodeURIComponent(message));
    }

    // 获取URL中的email参数
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmailFromUrl(decodeURIComponent(emailParam));
    }

    // 获取URL中的重定向URL，优先使用 redirect，其次使用 redirectUrl
    const redirect = searchParams.get('redirect');
    const redirectUrlParam = searchParams.get('redirectUrl');
    if (redirect) {
      setRedirectUrl(decodeURIComponent(redirect));
    } else if (redirectUrlParam) {
      setRedirectUrl(decodeURIComponent(redirectUrlParam));
    }
  }, [searchParams]);

  // Initialize Google Analytics with tracking ID
  useEffect(() => {
    // Initialize GA directly with the specific tracking ID
    initGA('G-1QXDHG1BLW');
  }, []);

  return (
      <LoginPageLayout loaded={loaded}>
        <SEO 
          title={t("auth.login.title")}
          description={t("auth.login.description")}
          keywords="login, sign in, account access, Anzir account, MysteryAct login"
          ogUrl={ogUrl}
          canonicalUrl={loginUrl}
        />
        <LoginLeftPanel loaded={loaded} />
        <LoginRightPanel 
          loaded={loaded} 
          initialEmail={emailFromUrl} 
          redirectUrl={redirectUrl || '/profile'}
        />
      </LoginPageLayout>
  );
};

export default Login;
